export class ForgetPassword {
    username: string;
    email: string;
}
